module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_footer_suns-c1eacf92b19ebd35486bacf397d3f47c.svg";